import { type Components, type Theme } from '@mui/material/styles';

import getStyleQuery from '../../../utils/tools/getStyleQuery';

// ----------------------------------------------------------------------

export function skeleton(theme: Theme): Components<Theme> {
    return {
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    [getStyleQuery()]: {
                        backgroundColor: theme.palette.background.neutral,
                    },
                },
                rounded: {
                    [getStyleQuery()]: {
                        borderRadius: Number(theme.shape.borderRadius) * 2,
                    },
                },
            },
        },
    };
}
